import { FeaturesStatesService } from '@app/services/features-states.service';
import { Component, HostListener, OnInit } from '@angular/core';
import { PWAInstallService } from '@app/services/pwa/pwainstall.service';
import { NotificationMiddlewareService } from '@app/services/middleware/notification-middleware.service';
import { SignalRService } from '@app/services/signalr.service';
import { AuthService } from '@app/auth/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    private backgroundStart = null;
    constructor(
        private _pwaInstall: PWAInstallService,
        private _notificationMiddleware: NotificationMiddlewareService,
        private _signalRService: SignalRService,
        private _authService: AuthService,
        private _featureStatesServiceService: FeaturesStatesService
    ) {}

    @HostListener('window:beforeinstallprompt', ['$event'])
    onBeforeInstallPrompt(e) {
        const existingUser = JSON.parse(localStorage.getItem('existingUser'));
        e.preventDefault();
        this._pwaInstall.promptEvent = e;
        if (!existingUser) {
            e.preventDefault();
            this._pwaInstall.setUpBottomSheet();
        }
    }

    @HostListener('window:appinstalled', ['$event'])
    onAppInstalled(e) {
        this._pwaInstall.trackInstalled();
    }

    @HostListener('document:visibilitychange')
    onResume() {
        if (document.hidden) {
            this.backgroundStart = Date.now();
            return;
        }

        if (this.backgroundStart === null) return;

        const timeInBackground = Date.now() - this.backgroundStart;
        console.log("[app component] Sense is back from background after ", timeInBackground, " (ms)")
        this.backgroundStart = null;

        if (!this._authService.isAuthUserLoggedIn()) {
            console.log("[app component] user not logged in");            
            return
        };

        const accessTokenExpiryTime = this._authService.getAccessTokenExpiryTime();
        const isAccessTokenExpired = new Date() > accessTokenExpiryTime;
        console.log("[app component] access token expired = ",isAccessTokenExpired)
        if (isAccessTokenExpired) {
            this._authService.refreshToken().subscribe({
                next: () => {
                    this.resumeConnections();
                },
                error: () => {
                    this._authService.logout();
                }
            });
        } 
        else if (timeInBackground > 60 * 1000 ) {
            this.resumeConnections();
        }
    }

    private resumeConnections() {
        this._featureStatesServiceService.getFeatureStates();
        console.log("[app component] signalR connected = ",this._signalRService.isConnected())
        if (!this._signalRService.isConnected()) {
            this._signalRService.startConnection();
            this._signalRService.registerOnServerEvents();
        }
        else this._signalRService.updateConnecedStatus();
    }

    ngOnInit(): void {
        this._notificationMiddleware.init();        
        this._authService.loggedIn$.subscribe(status => {
            console.log('[app component] User logged in = ', status);
            if (status) {
                this._signalRService.startConnection();
                this._signalRService.registerOnServerEvents();
            }
        });
    }
}
